module.exports = __webpack_public_path__ + "static/media/creative-quarter-logo.b0136494.png";